import { render, staticRenderFns } from "./CreateCampaignSetupsSummary.vue?vue&type=template&id=25926e85"
import script from "./CreateCampaignSetupsSummary.vue?vue&type=script&lang=js"
export * from "./CreateCampaignSetupsSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports